import { config } from './config';
import axios from "axios";

export const creationNotLaunchedFoundKeywordsService = {
    get,
    config
};

function get(params){

    let axiosConfig = {}

    let endpoint;

    // Append to request.
    axiosConfig['params'] = params;

    endpoint = '/api/creation/not-launched-found-keyword-network-users/';

    return new Promise((resolve, reject) => {
      axios
        .get(`${config.apiUrl}${endpoint}`, axiosConfig)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}




